import { render } from "./PurchasingFundForm.vue?vue&type=template&id=472a9a14&scoped=true"
import script from "./PurchasingFundForm.vue?vue&type=script&lang=js"
export * from "./PurchasingFundForm.vue?vue&type=script&lang=js"

import "./PurchasingFundForm.vue?vue&type=style&index=0&id=472a9a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472a9a14"]])

export default __exports__